import { fetchWarehousesAndAppliances } from '#action/warehouse/warehouses';
import { ProjectsFilterOptionService } from '#service/autocomplete-service/service';
import { FilterOption } from '#service/autocomplete-service/option';
import { uuidv4 } from '#helper';

const withAppliancesOptions = [
  { label: 'All', value: 'all', id: '0', default: true },
  { label: 'With appliances', value: 'withAppliance', id: '1' },
  { label: 'Empty', value: 'empty', id: '2' }
];

const searchProps = {
  type: 'Search',
  name: 'search',
  label: 'Search a site',
  relatedTo: 'warehouse-manager',
  id: uuidv4()
};

const projectComponent = {
  type: 'MultipleSelect',
  name: 'project',
  label: 'Project',
  relatedTo: 'warehouse-manager',
  id: uuidv4(),
  fetchOptionsService: ProjectsFilterOptionService,
  searchFields: ['title']
};

const withAppliances = {
  type: 'RadioButtonsGroup',
  name: 'whAppliance',
  label: 'Application status',
  relatedTo: 'warehouse-manager',
  id: uuidv4(),
  options: withAppliancesOptions.map(o => new FilterOption(o, o.label))
};

const filterConfig = {
  customActions: {
    fetchFilterData: fetchWarehousesAndAppliances
  },
  searchProps,
  components: [projectComponent, withAppliances]
};

export default filterConfig;
